import React from 'react';
import { Flex } from '@chakra-ui/react';
import { Header } from '../Header';
import { Footer } from '../Footer';

function Layout({ children }) {
  return (
    <>
      <Header />
      <main id='main'>
        <Flex flexDirection='column' margin='auto'>
          {children}
        </Flex>
      </main>
      <Footer />
    </>
  );
}

export default Layout;
